<app-autocomplete-select
  [formControl]="control"
  [options]="options"
  [optionScope]="(countryIso || countryId) + ':' + (stateIso || stateId)"
  [searchFn]="search"
  [preloadFn]="preload"
  [placeholder]="placeholder"
  [selectClass]="selectClass"
  (blur)="touched()">
</app-autocomplete-select>
